import { HttpContext, HttpContextToken } from '@angular/common/http';

export const NURSE_CONTEXT = new HttpContextToken<boolean>(() => false);
export function applyNurseHttpContext() {
  return new HttpContext().set(NURSE_CONTEXT, true);
}
